import api from './api';
import { User } from '../types';



// export const userapi = async() => {
//   try {
//     const response = await api.get('/users/all'); 
//     return response.data;
//   } catch (error: any) {
//     console.error('Error fetching users:', error);
//     throw new Error(error?.response?.data?.error || error.message);
//   }
// };


// Description: Get all employees
// Endpoint: GET /api/employees
// Request: {}
// Response: { employees: User[] }
export const getEmployees = async () => {
  try {
    console.log('API: Fetching employees from /api/employees');
    const response = await api.get('/employeesAll');
    console.log('API: Successfully fetched employees:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('API: Error fetching employees:', error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Get employee by ID
// Endpoint: GET /api/users/:id
// Request: { id: string }
// Response: { employee: User }
export const getEmployeeById = async (id: string) => {
  try {
    console.log(`API: Fetching employee by ID: ${id}`);
    const response = await api.get("/employee_by_ID/{employee_id}", {
      params: { ID: id },
    });
    console.log('API: Successfully fetched employee:', response.data);
    return { employee: response.data };
  } catch (error: any) {
    console.error(`API: Error fetching employee ${id}:`, error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Create new employee
// Endpoint: POST /api/users
// Request: { employee: Partial<User> }
// Response: { success: boolean, message: string, employee: User }
export const createEmployee = async (employee) => {

  try {
    console.log('API: Creating new employee:', employee);
    const response = await api.post('/add_employee', {
      ...employee
    });
    console.log('API: Successfully created employee:', response.data);
    return {
      success: true,
      message: response.data.message,
      employee: response.data
    };
  } catch (error: any) {
    console.error('API: Error creating employee:', error);
    throw new Error(error?.response?.data?.error || "Personal details were missing or invalid. Please check the input and try again.");
  }
};

// Description: Update employee
// Endpoint: PUT /api/employees/:id
// Request: { id: string, employee: Partial<User> }
// Response: { success: boolean, message: string, employee: User }


export const updateEmployee = async (id: string, employee: Partial<User>) => {
  // try {
  //   if (!id) {
  //     throw new Error("Employee ID missing");
  //   }

    console.log("API: Updating employee with ID:", id);
    console.log("Payload going to backend:", employee);

    const response = await api.put(
      `/update_employee/${id}`,
      employee
    );

    console.log("API: Successfully updated employee:", response.data);

    return {
      success: true,
      message: response.data.message,
      employee: response.data.employee,
    };
  // } catch (error: any) {
  //   console.error(`API: Error updating employee ${id}:`, error);
  //   throw new Error(
  //     error?.response?.data?.detail ||
  //     error?.response?.data?.error ||
  //     error.message
  //   );
  // }
};

// Description: Delete employee soft delete
// Endpoint: DELETE /api/users/:id
// Request: { id: string }
// Response: { success: boolean, message: string }


export const deleteEmployee = async (id: string) => {
  try {
    console.log("API: Deleting employee", id);

    const response = await api.delete("/employee_bulk_delete", {
      data: {
        id: [id],
      },
    });

    console.log("API: Successfully deleted employee:", response.data);

    return {
      success: true,
      message: response.data.message,
    };
  } catch (error: any) {
    console.error("API: Error deleting employee:", error);
    throw new Error(
      error?.response?.data?.detail || error.message
    );
  }
};

// Description: Delete employee permanently
export const permanentDeleteEmployee = async (id: string) => {
  return api.delete("/employee_bulk_permanent_delete", {
    data: {
      id: [id],
    },
  });
};

// Description: Reactive employee
export const reactivateEmployee = async (id: string) => {
  return api.delete("/employee_reactive", {
    data: {
      id: [id],
    },
  });
};



// Description: Seed database with sample employee data
// Endpoint: POST /api/employees/seed
// Request: {}
// Response: { success: boolean, message: string, created_count: number, skipped_count: number, created_employees: User[], default_password: string }
// export const seedEmployees = async () => {
//   try {
//     console.log('API: Seeding sample employee data');
//     const response = await api.post('/api/employees/seed');
//     console.log('API: Successfully seeded employee data:', response.data);
//     return response.data;
//   } catch (error: any) {
//     console.error('API: Error seeding employee data:', error);
//     throw new Error(error?.response?.data?.detail || error?.response?.data?.error || error.message);
//   }
// };

export const uploadEmployeeExcel = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.post("/api/employees/bulk/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

/* ─── Employee Documents (optional uploads, stored on GCS bucket: teamlio) ─── */

export type EmployeeDocType =
  | "aadhar"
  | "pan"
  | "cv"
  | "relieving_letter"
  | "form16"
  | "experience_letter";

export const uploadEmployeeDocument = async (
  employeeId: string,
  docType: EmployeeDocType,
  file: File,
) => {
  const formData = new FormData();
  formData.append("doc_type", docType);
  formData.append("file", file);

  const response = await api.post(
    `/employee/${employeeId}/upload_document`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return response.data;
};

export const getEmployeeDocuments = async (employeeId: string) => {
  const response = await api.get(`/employee/${employeeId}/documents`);
  return response.data;
};

export const deleteEmployeeDocument = async (
  employeeId: string,
  docType: EmployeeDocType,
) => {
  const response = await api.delete(`/employee/${employeeId}/document`, {
    params: { doc_type: docType },
  });
  return response.data;
};

export const downloadEmployeeTemplate = async () => {
  const response = await api.get("/api/employees/bulk/template", {
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "employee_bulk_template.xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};


export const sendEmail = async (to: string, subject: string, message: string) => {
  try {
    console.log("API: Sending email to:", to);
    const response = await api.post('/api/send-email', {
      to,
      subject,
      message,
    });
    console.log("API: Email sent successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("API: Error sending email:", error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

export const downloadOfferLetter = async (id: string, offerValidTill: string, offerDate: string, date: any, tc_id?: string) => {

  const response = await api.get("/offer_latter_admin", {
    params: {
      ID: id,
      offer_valid_till: offerValidTill,
      status: "Pending",
      offer_date: offerDate,
      tc_id: tc_id// Pass empty string if no terms and conditions
    },
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "offer_letter.pdf");

  document.body.appendChild(link); 
  link.click();
  link.remove();
};

export const updateOfferStatus = async (id: string, status: string) => {
  try {
    console.log("API: Updating offer status", { id, status });

    const response = await api.put("/update_offer_status", null, {
       params: {
        ID: id,
        offer_status: status
      }
    });

    console.log("API: Offer status updated:", response.data);

    return response.data;
  } catch (error: any) {
    console.error("API: Error updating offer status:", error);
    throw new Error(
      error?.response?.data?.detail || error.message
    );
  }
};

export const viewOfferLetter = async (id: string) => {
  try {
    console.log("API: Downloading employee offer letter", id);

    const response = await api.get("/offer_latter_employee",{
      params: {
        ID: id,
      },
      responseType: "blob"
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "offer_letter.pdf");

    document.body.appendChild(link);
    link.click();
    link.remove();

  } catch (error: any) {
    console.error("API: Error downloading offer letter:", error);
    throw new Error(
      error?.response?.data?.detail || error.message
    );
  }
};

export const downloadJoiningLetter = async (id: string, probationPeriod?: string, tc_id?: string) => {

  const response = await api.get("/joining_letter", {
    params: {
      ID: id,
      probationPeriod: probationPeriod,
      tc_id: tc_id,
    },
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "joining_letter.pdf");

  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const sendjoiningLetterEmail = async (id: string, probationPeriod?: string, tc_id?: string) => {
  try {
    console.log("API: Sending joining letter email to employee ID:", id);
    
    // Send as QUERY PARAMETERS, not in the body
    const response = await api.post('/send_joining_letter', null, {
      params: {
        ID: id,                           // Uppercase ID as expected by backend
        probation_period: probationPeriod|| null, // Use underscore format
        tc_id: tc_id,           // Add empty terms_and_conditions parameter
      }
    });
    
    console.log("API: Joining letter email sent successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("API: Error sending joining letter email:", error);
    throw new Error(error?.response?.data?.detail?.[0]?.msg || error?.response?.data?.error || error.message);
  }
};

export const sendOfferLetterEmail = async (id: string, offerValidTill: string, offerDate: string, date:any, tc_id: string) => { 
  try {
    console.log("API: Sending offer letter email to employee ID:", id);
    
    // Send as QUERY PARAMETERS, not in the body
    const response = await api.post('/send_offer_letter',null,{
      params: {
        ID: id,                                    // Uppercase ID as expected by backend
        offer_valid_till: offerValidTill,          // Use underscore format
        status: "Pending",                         // Default status
        offer_date: offerDate,// Current date
        tc_id: tc_id, // Pass terms and conditions if available
      }
    });
    
    console.log("API: Offer letter email sent successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("API: Error sending offer letter email:", error);
    throw new Error(error?.response?.data?.detail?.[0]?.msg || error?.response?.data?.error || error.message);
  }
};

// Add this function for downloading salary slip PDF
export const downloadSalarySlip = async (id: string, month: number, year: number, tc_id?: string) => {
  try {
    console.log("API: Downloading salary slip for employee:", id, "Month:", month, "Year:", year);
    
    const response = await api.get("/salary_pdf", {
      params: {
        ID: id,
        month: month,
        year: year,
        tc_id: tc_id,
      },
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `salary_slip_${month}_${year}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return response.data;
  } catch (error: any) {
    console.error("API: Error downloading salary slip:", error);
    throw new Error(error?.response?.data?.detail?.[0]?.msg || error?.response?.data?.error || error.message);
  }
};

// Add this function for sending salary slip email
export const sendSalarySlipEmail = async (id: string, month: number, year: number, tc_id?: string) => {
  try {
    console.log("API: Sending salary slip email to employee ID:", id, "Month:", month, "Year:", year);
    
    // Send as QUERY PARAMETERS
    const response = await api.post('/send_salary_slip', null, {
      params: {
        ID: id,
        month: month,
        year: year,
        tc_id: tc_id,
      }
    });
    
    console.log("API: Salary slip email sent successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("API: Error sending salary slip email:", error);
    throw new Error(error?.response?.data?.detail?.[0]?.msg || error?.response?.data?.error || error.message);
  }
};